/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = [".cs-loading[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:center;height:100vh;font-size:16px;color:#555}.cs-loading[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{margin-right:8px}"];
export { styles as styles };

